/* eslint-disable no-unused-vars */
import React from "react";
import { Box, Link, List, Typography } from "@mui/material";
import { theme } from "~/utils";
import { Collapsibles } from "../..";
import { TSidebarItem } from "~/components/Layout";
import { SidebarListItem } from "../SidebarListItem";
import { CollapsibleList } from "../CollapsibleList";
import { DrawerHeader, StyleDrawer } from "../../style";
import { IconLogout } from "@tabler/icons-react";
import { useAuth, useSidebar } from "~/contexts";

export type SidebarContentProps = {
  isDrawerOpen: boolean;
  collapsibles: Collapsibles;
  sidebarItems: TSidebarItem[];
  toggleCollapsible: (collapsibleName: keyof Collapsibles) => void;
};
export const SidebarContent: React.FC<SidebarContentProps> = (props) => {
  const { isDrawerOpen, sidebarItems, collapsibles, toggleCollapsible } = props;
  const { logout } = useAuth();
  const { closeLogo, openLogo } = useSidebar();

  return (
    <StyleDrawer variant="permanent" open={isDrawerOpen}>
      <DrawerHeader
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <img src={isDrawerOpen ? openLogo : closeLogo} height={40} />
      </DrawerHeader>

      <List sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        {sidebarItems.map((sidebarItem) => {
          const { collapsibleName, text, nested, ...rest } = sidebarItem as any;

          return (
            <React.Fragment key={`sidebar-list-item-${text}`}>
              <SidebarListItem
                text={text}
                isDrawerOpen={isDrawerOpen}
                isCollapsibleOpen={
                  collapsibleName
                    ? collapsibles[collapsibleName as keyof Collapsibles]
                    : false
                }
                toggleCollapsible={
                  collapsibleName
                    ? () => toggleCollapsible(collapsibleName)
                    : undefined
                }
                {...rest}
              />
              {nested && collapsibleName && (
                <CollapsibleList
                  isDrawerOpen={isDrawerOpen}
                  sidebarItem={sidebarItem}
                  isOpen={collapsibles[collapsibleName as keyof Collapsibles]}
                />
              )}
            </React.Fragment>
          );
        })}
        <SidebarListItem
          text="Sair"
          icon={<IconLogout />}
          hideChevronIcon
          onClick={() => logout()}
          isDrawerOpen={isDrawerOpen}
          sx={{ marginTop: "auto", background: theme.palette.error.main }}
        />
      </List>
    </StyleDrawer>
  );
};
